import React from "react";

import { HorizontalListing } from "./index.jsx";

const StaticListingList = ({ cart, readOnly }) => {
  const items = cart.items.map((item) => (
    <HorizontalListing
      key={item?.listing_id}
      item={item}
      cart={cart}
      readonly={readOnly}
    />
  ));

  return <ul className="product-list">{items}</ul>;
};

export default StaticListingList;
